import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
import { seatPickerEventsValidator as swapSeatPickerEventsValidator } from '../../seat-picker/types/events';
import { defaultSwapSeatPickerAssets, swapSeatPickerAssetsValidator } from './assets';
import { defaultSwapSeatPickerConfig, swapSeatPickerConfigValidator } from './config';
import { defaultSwapSeatPickerDisplayText, swapSeatPickerDisplayTextValidator } from './display-text';
export const defaultSwapSeatPickerProps = {
    orderId: undefined,
    showtimeId: undefined,
    assets: defaultSwapSeatPickerAssets,
    config: defaultSwapSeatPickerConfig,
    displayText: defaultSwapSeatPickerDisplayText,
    events: {}
};
export const swapSeatPickerPropsValidatorSchema = {
    orderId: nonEmptyStringValidator,
    showtimeId: nonEmptyStringValidator,
    friendSeatIds: Validator.optional(Validator.array({ items: nonEmptyStringValidator })),
    assets: swapSeatPickerAssetsValidator,
    config: swapSeatPickerConfigValidator,
    displayText: swapSeatPickerDisplayTextValidator,
    events: swapSeatPickerEventsValidator
};
export const swapSeatPickerPropsValidator = Validator.object(swapSeatPickerPropsValidatorSchema);
